import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ProductImage from '@sprinx/react-com/ProductImage';
import IconButtonDelete from '@sprinx/react-mui-components/IconButtonDelete';
import ListPretty from '@sprinx/react-mui-components/ListPretty';
import clsx from 'clsx';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ShoppingListSubject } from '../../../api/shoppingLists';
import ShoppingListItemSku from './ShoppingListItemSku';
import ShoppingListItemName from './ShoppingListItemName';

const ShoppingListExpanded = ({
  classes = {},
  className,
  enabeleEditation = false,
  onRemoveSubject,
  subjects,
}: {
  classes?: Record<string, string>;
  className?: string;
  enabeleEditation?: boolean;
  onRemoveSubject?: (index: number) => void;
  subjects: ShoppingListSubject[];
}) => {
  const handleDeleteItem = React.useCallback(
    (idx) => () => {
      if (onRemoveSubject) onRemoveSubject(idx);
    },
    [onRemoveSubject],
  );

  return (
    <ListPretty className={clsx(classes.subjectsList, className)} disablePadding>
      {subjects.map((i, index) => (
        <ListItem key={index.toString()} divider={index !== subjects.length - 1}>
          <div className={classes.container}>
            <ListItemAvatar>
              <ProductImage src={i.product.image} alt={i.product.name} size='small' />
            </ListItemAvatar>
            <div className={classes.itemContentContent}>
              <ShoppingListItemName item={i} />
              <ShoppingListItemSku sku={i.product.sku} />
            </div>
          </div>
          <div className={classes.quantity}>
            {i.quantity} {i.unit || 'ks'}
          </div>
          {enabeleEditation && <IconButtonDelete onClick={handleDeleteItem(index)} />}
        </ListItem>
      ))}
    </ListPretty>
  );
};

const ShoppingListExpandedStyled = withStyles((theme) => ({
  item: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  container: {
    flexGrow: 1,
    display: 'flex',
  },
  quantity: {
    minWidth: theme.spacing(7),
    display: 'flex',
    justifyContent: 'flex-end',
    paddingLeft: theme.spacing(0.5),
  },
  itemContentContent: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
  },
}))(ShoppingListExpanded) as typeof ShoppingListExpanded;

export default ShoppingListExpandedStyled;
